import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    assignAddOnToProduct,
    detachProductAddOn,
    updateProductAddOn,
    type AssignAddOnPayload,
    type UpdateAddOnAssignmentPayload,
} from '../services/productAddons';
import { productAddOnKeys } from './useProductAddOnsQuery';

export function useProductAddOnMutations(productId: string) {
    const qc = useQueryClient();

    const invalidate = () => {
        qc.invalidateQueries({ queryKey: productAddOnKeys.list(productId) });
    };

    const assignMutation = useMutation({
        mutationFn: (payload: AssignAddOnPayload) => assignAddOnToProduct(productId, payload),
        onSuccess: invalidate,
    });

    const updateMutation = useMutation({
        mutationFn: ({ addonId, payload }: { addonId: string; payload: UpdateAddOnAssignmentPayload }) =>
            updateProductAddOn(productId, addonId, payload),
        onSuccess: invalidate,
    });

    const detachMutation = useMutation({
        mutationFn: (addonId: string) => detachProductAddOn(productId, addonId),
        onSuccess: invalidate,
    });

    return { assignMutation, updateMutation, detachMutation };
}
